import { FormControlLabel, Typography, styled } from '@mui/material';
import type { SxProps, Theme } from '@mui/material';
import { Drawer } from '@mui/material';

export const DRAWER_WIDTH = 380;

const browseFilterDrawerSx: SxProps<Theme> = {
  zIndex: (theme) => theme.zIndex.modal + 1,
};

const aboveBrowseFilterDrawerSx: SxProps<Theme> = {
  zIndex: (theme) => theme.zIndex.modal + 2,
};

export { browseFilterDrawerSx, aboveBrowseFilterDrawerSx };

export const StyledDrawer = styled(Drawer)({
  '& .MuiDrawer-paper': {
    width: DRAWER_WIDTH,
    boxSizing: 'border-box',
    position: 'fixed',
    height: '100%',
    border: '0px',
    zIndex: 12000,
  },
});

export const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  height: '100vh',
});

export const Header = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing(2),
  borderBottom: `1px solid ${theme.palette.divider}`,
}));

export const Content = styled('div')(({ theme }) => ({
  flex: 1,
  padding: theme.spacing(2),
  overflowY: 'auto',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

export const Footer = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
  padding: theme.spacing(2),
  borderTop: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.paper,
  alignItems: 'center',
}));

export const Section = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1.5),
}));

export const SectionTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  color: theme.palette.text.primary,
  marginBottom: theme.spacing(0.5),
}));

export const FilterItem = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(1),
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.grey[50],
  gap: theme.spacing(1),
}));

export const SavedFilterItem = styled(FilterItem, {
  shouldForwardProp: (prop) => prop !== 'isActive',
})<{ isActive?: boolean }>(({ theme, isActive }) => ({
  cursor: 'pointer',
  transition: 'all 0.2s ease',
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
    borderColor: theme.palette.primary.main,
  },
  ...(isActive && {
    backgroundColor: theme.palette.primary.light + '20',
    borderColor: theme.palette.primary.main,
  }),
}));

export const FilterText = styled(Typography)({
  flex: 1,
  fontSize: '0.875rem',
});

export const LogicalOperatorChip = styled('span')(({ theme }) => ({
  backgroundColor: theme.palette.primary.light,
  color: theme.palette.primary.contrastText,
  padding: '2px 8px',
  borderRadius: 4,
  fontSize: '0.75rem',
  fontWeight: 600,
  marginRight: theme.spacing(1),
}));

export const NoFiltersText = styled(Typography)(({ theme }) => ({
  textAlign: 'center',
  color: theme.palette.text.secondary,
  padding: theme.spacing(2),
  fontStyle: 'italic',
}));

export const FormRow = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1.5),
}));

export const RangeRow = styled('div')({
  display: 'flex',
  gap: '8px',
  '& > *': {
    flex: 1,
  },
});

export const ChipsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(0.5),
}));

export const AdvancedToggle = styled(FormControlLabel)({
  marginTop: '0px',
  marginBottom: '0px',
});
